import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GlobalState {
  mode: 'light' | 'dark';
  userInfo?: UserInfoType | null | undefined;
}

interface UserInfoType {
  id: string;
  role: string;
  email: string;
  name?: string;
}

//default values
const initialState: GlobalState = {
  mode: 'light',
  userInfo: undefined,
};

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
    // Pokud bys chtěl nastavovat přímo, můžeš přidat i payload variantu:
    setModeDirectly: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.mode = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<UserInfoType | null>) => {
      state.userInfo = action.payload;
    },
    clearUserInfo: (state) => {
      state.userInfo = null;
    },
  },
});

export const { setMode, setModeDirectly, setUserInfo, clearUserInfo } = globalSlice.actions;

export default globalSlice.reducer;
